import React from 'react'
import Slider from 'react-slick'
import exploreImg from "../mov/jpg3/1870-2000_000.jpg";
import hotkeys from 'hotkeys-js';
import classnames from 'classnames';

import Pannellum from 'pannellum-react/es/elements/Pannellum';

const sliderSettings = {
  dots: false,
  lazyLoad: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '0',
  arrows: true,
  draggable: false,
  swipe: false
}


const HotspotCardMedia = React.memo(props => {
  const { hotspot } = props;

  if (hotspot.is360Image) {
    return (
      <Pannellum image={hotspot.mediaSrc} autoLoad />
    );
  }

  if (hotspot.isVideo) {
    return (
      <video controls autoPlay muted src={hotspot.mediaSrc}></video>
    );
  }

  const aspectRatio = hotspot.mediaSrc ? (
    hotspot.height / hotspot.width
  ) : (
    3 / 4
  );

  return (
    <figure style={{
      position: 'relative',
      margin: 0,
      paddingBottom: aspectRatio * 100 + '%',
    }}>
      <img
        src={hotspot.mediaSrc || exploreImg}
        alt={hotspot.name.replace(/&shy;/g, '')}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </figure>
  );
});

const HotspotCard = React.memo(props => {
  const { hotspot } = props;

  return (
    <div key={hotspot.id}>
      <div className='card'>
        <div className="card-year">
          <h5>{hotspot.year}</h5>
        </div>
        <div className="card-image">
          <HotspotCardMedia hotspot={hotspot} />
        </div>
        <div className="card-content">
          <h2 dangerouslySetInnerHTML={{ __html: hotspot.name }}></h2>
          <p dangerouslySetInnerHTML={{ __html: hotspot.content }}></p>
        </div>
      </div>
    </div>
  );
});

const PrevArrow = React.memo(props => {
  const { className, style, customOnClick, hotspot } = props;

  if (!hotspot) return null;

  return (
    <div
      className={className}
      style={{ ...style, display: 'flex', justifyContent: 'flex-start' }}
      onClick={customOnClick}
    >
      {hotspot.name}
    </div>
  )
});

const NextArrow = React.memo(props => {
  const { className, style, customOnClick, hotspot } = props;

  if (!hotspot) return null;

  return (
    <div
      className={className}
      style={{ ...style, display: 'flex', justifyContent: 'flex-end' }}
      onClick={customOnClick}
    >
      {hotspot.name}
    </div>
  )
});

export default class CardCarousel extends React.PureComponent {
  state = {
    currentSlide: 0
  }

  handleKeyPress = (event, handler) => {
    if (!this.props.isOpen) return;

    switch (handler.key) {
      case 'left':  this.toPrev(); break;
      case 'right': this.toNext(); break;
      case 'esc':   this.props.onPressClose(); break;
      default:      break;
    }
  }

  get slider() { return this.props.sliderRef.current; }

  toNext = () => {
    if (!this.slider || !this.props.isOpen) return;

    // slickNext() doesn't respect infinite: false
    if (this.state.currentSlide < this.props.hotspots.length - 1) {
      this.slider.slickNext();
    }
  }

  toPrev = () => {
    if (!this.slider || !this.props.isOpen) return;

    // slickPrev() doesn't respect infinite: false
    if (this.state.currentSlide > 0) {
      this.slider.slickPrev();
    }
  }

  componentDidMount() {
    hotkeys('left,right,esc', this.handleKeyPress);
  }

  componentWillUnmount() {
    hotkeys.unbind('left,right,esc');
  }

  // NOTE: We are using beforeChange because afterChange isn't always triggered
  handleBeforeChange = (oldIndex, newIndex) => {
    this.setState({ currentSlide: newIndex });

    if (this.props.setDecade) {
      this.props.setDecade(this.props.hotspots[newIndex].year);
    }
  }

  get prevArrow() {
    return (
      <PrevArrow
        hotspot={this.props.hotspots[this.state.currentSlide - 1]}
        customOnClick={this.toPrev}
      />
    );
  }

  get nextArrow() {
    return (
      <NextArrow
        hotspot={this.props.hotspots[this.state.currentSlide + 1]}
        customOnClick={this.toNext}
      />
    );
  }

  render() {
    return (
      <div className={classnames("slider-container", this.props.className)}>
        <div className="card-carousel-bg"></div>
        <Slider ref={this.props.sliderRef}
          className="card-slider"
          {...sliderSettings}
          beforeChange={this.handleBeforeChange}
          prevArrow={this.prevArrow}
          nextArrow={this.nextArrow}
        >
         {this.props.hotspots.map(hotspot => <HotspotCard key={hotspot.id} hotspot={hotspot} />)}
        </Slider>
        <button className="hamburger hamburger--vortex is-active" type="button"
          onClick={this.props.onPressClose}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button> 
      </div>
    );
  }
}
